export default __webpack_public_path__ + "static/media/royalmail.85d6a77e.png";